import { toast } from "sonner";
import { Ban, CheckCircle2, Star, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { displayName } from "./shared";

export const Section = ({ title, sub, testId, children }) => (
  <section className="mt-10 first:mt-8" data-testid={testId}>
    <h2 className="font-display text-lg font-bold text-petrol">{title}</h2>
    <p className="mt-0.5 text-xs text-slate-500">{sub}</p>
    <div className="mt-4">{children}</div>
  </section>
);

export const Empty = ({ children }) => (
  <p className="rounded-2xl border border-dashed border-slate-300 bg-white/60 px-6 py-8 text-center text-sm text-slate-500">
    {children}
  </p>
);

export const EditableStars = ({ lead, onChanged }) => {
  const current = Number(lead.payload?.rating) || 0;
  const rate = async (e, n) => {
    e.stopPropagation();
    try {
      await api.patch(`/admin/leads/${lead.id}`, { rating: n });
      toast.success(`Avaliação de ${displayName(lead)}: ${n} estrela${n > 1 ? "s" : ""}.`);
      onChanged();
    } catch {
      toast.error("Falha ao salvar avaliação.");
    }
  };
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={`rating-stars-${lead.id}`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          onClick={(e) => rate(e, n)}
          aria-label={`Avaliar ${n} estrelas`}
          data-testid={`rating-star-${lead.id}-${n}`}
          className="rounded p-0.5 transition-transform hover:scale-125"
        >
          <Star
            className={`h-4 w-4 ${n <= current ? "fill-amber-400 text-amber-400" : "text-slate-300 hover:text-amber-300"}`}
          />
        </button>
      ))}
    </span>
  );
};

export const CardActions = ({ lead, onChanged }) => {
  const toggleBlock = async (e) => {
    e.stopPropagation();
    const toBlock = lead.status !== "bloqueado";
    try {
      await api.patch(`/admin/leads/${lead.id}`, { status: toBlock ? "bloqueado" : "novo" });
      toast.success(toBlock ? "Bloqueado da rede." : "Desbloqueado.");
      onChanged();
    } catch {
      toast.error("Falha ao atualizar.");
    }
  };

  const remove = async (e) => {
    e.stopPropagation();
    if (!window.confirm(`Excluir ${displayName(lead)} definitivamente?`)) return;
    try {
      await api.delete(`/admin/leads/${lead.id}`);
      toast.success("Excluído da rede.");
      onChanged();
    } catch {
      toast.error("Falha ao excluir.");
    }
  };

  return (
    <span className="flex shrink-0 items-center gap-1">
      <button
        onClick={toggleBlock}
        aria-label="Bloquear ou desbloquear"
        data-testid={`rede-block-${lead.id}`}
        className="rounded-full p-2 text-slate-300 transition-colors hover:bg-red-50 hover:text-red-600"
      >
        {lead.status === "bloqueado" ? (
          <CheckCircle2 className="h-4 w-4" />
        ) : (
          <Ban className="h-4 w-4" />
        )}
      </button>
      <button
        onClick={remove}
        aria-label="Excluir"
        data-testid={`rede-delete-${lead.id}`}
        className="rounded-full p-2 text-slate-300 transition-colors hover:bg-red-50 hover:text-red-600"
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </span>
  );
};
